module.exports = __webpack_public_path__ + "img/complete_payment.ccda41de.svg";